import type { RouteObject } from 'react-router-dom';

import { defineHandle } from '@/app/routes/types';

import { deliveryChargesAccessRoles } from './access';

export const deliveryChargesRoutes: RouteObject[] = [
  {
    path: 'delivery-charges',
    async lazy() {
      const { DeliveryChargesPage } = await import('./pages/DeliveryChargesPage');
      return { Component: DeliveryChargesPage };
    },
    handle: defineHandle({
      roles: [...deliveryChargesAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.deliveryCharges',
    }),
  },
];
